<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Add Supplier</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <p>Follow these steps to add your locations from an excel spreadsheet:</p>
      <ol>
        <li>Open your excel file</li>
        <li>Select the row which contains the Company Legal Name, First Last name... and copy (Ctrl + C on Windows or CMD + C
          on Mac)</li>
        <li>Now go back to the Jet Fuel Tenders website and paste (Ctrl + V on Windows or CMD + V on Mac) your date in
          to the coresponding row</li>
      </ol>
      <p>
        <span [hidden]="loadingTemplate">
          Download <a (click)="downloadTemplate($event)" href="#">Contact Import Template</a> for Excel.
        </span>

        <span [hidden]="!loadingTemplate">
          <button class="btn btn-outline-dark btn-sm" type="button" disabled>
            <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
            <span role="status" class="ms-2">Generating Excel Template</span>
          </button>
          <span class="text-muted small">Please wait while we prepare your contacts template.</span>
        </span>
      </p>
      <!--            <hot-table-->
      <!--                [data]="dataTable"-->
      <!--                [minRows]="8"-->
      <!--                [colHeaders]="true"-->
      <!--                [rowHeaders]="true"-->
      <!--                [colWidths]="[135, 135, 135, 165, 135]"-->
      <!--                [readOnly]="loading"-->
      <!--                height="240"-->
      <!--                startRows="3"-->
      <!--                hotId="suppliersSpreadsheet">-->
      <!--                <hot-column data="name" title="Company Name"></hot-column>-->
      <!--                <hot-column data="contact.first_name" title="First Name"></hot-column>-->
      <!--                <hot-column data="contact.last_name" title="Last Name"></hot-column>-->
      <!--                <hot-column data="contact.email" title="Email"></hot-column>-->
      <!--                <hot-column data="contact.phone" title="Phone"></hot-column>-->
      <!--            </hot-table>-->
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-light" (click)="close()">Close</button>
  <jft-submit-button (onClick)="submitSuppliers()" [class]="'btn btn-primary'" [title]="'Save'" [disabled]="loading"
    [loading]="loading" [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
  </jft-submit-button>
</div>